module.exports = __webpack_public_path__ + "img/MBoC_Small_White@2x.59754578.png";